import { computed, useHost } from "vue";
import { closestAcrossShadowBoundaries } from "@/runtime/shared/shadow-dom";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import type { ChatBubbleProps } from "./chat.types";
import { chatBubbleClasses } from "./chat.styles";
import { getChatGroupSide } from "./useChat";

export interface UseChatBubbleOptions {
  props: Readonly<ChatBubbleProps>;
}

export const useChatBubble = (options: UseChatBubbleOptions) => {
  const { props } = options;
  const host = useHost();
  const groupHost = host ? closestAcrossShadowBoundaries(host, "e-chat-group") : null;

  const classes = computed(() => {
    const side = groupHost ? getChatGroupSide(groupHost) : "left";
    return mergeClassProp(chatBubbleClasses({ side }), props.class);
  });

  return { classes };
};
